module.exports = __webpack_public_path__ + "img/logo_new.65507c2c.svg";